import { render } from "./SystemDialogOptions.vue?vue&type=template&id=f0b591d4"
import script from "./SystemDialogOptions.vue?vue&type=script&lang=js"
export * from "./SystemDialogOptions.vue?vue&type=script&lang=js"

import "./SystemDialogOptions.vue?vue&type=style&index=0&id=f0b591d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__